import React, { useEffect, useRef, useState } from "react";

import { useTranslation } from "react-i18next";

import { useReduxSelector } from "@hooks/useReduxSelector";
import {
  SvgCheapListIcon,
  SvgFunnelIcon,
  SvgImportData
} from "@routes/IconeSvg";

import "@css/pages/employer/listeEmployer.css";

import BtnActions from "@components/buttons/ButtonsModals";
import CheckboxSimple from "@components/tailwindComponents/CheckboxSimple";
import ButtonCloseModal from "@components/tailwindComponents/CloseModal";
import ListboxEmploye from "@components/tailwindComponents/ListboxEmploye";
import ListboxGroupe from "@components/tailwindComponents/ListboxGroupe/index";
import ListboxSimple from "@components/tailwindComponents/ListboxSimple";
import useGenderType from "@pages/shared/employeFormNew/PersonnalInformations/hooksGenderType";

const SideCollapse = (props) => {
  const {
    TableImportList,
    selectedColumn: parentSelectedColumn,
    setSelectedColumn: setParentSelectedColumn,
    handleDataForChange,
    selectedItemNumber,
    allPostes,
    allPermissions,
    //allUsers,
    // DefaultCountryList,
    handleSaveData,
    dataForChange,
    emplacementList,
    setDataForChange,
    tempDataForChange,
    isOpen,
    onClose,
    hideCta = false,
    bulkMode = false,
    title = "Injecter des données"
  } = props;

  const { t } = useTranslation([
    "pages.employés.importation",
    "components.liSimple"
  ]);

  const { allGenderTypes: translaGenre } = useGenderType();

  const [internalExpanded, setInternalExpanded] = useState(false);
  const [dataInjection, setDataInjection] = useState(false);
  const [columnVisible, setColumnVisible] = useState(false);
  const [selectedColumn, setSelectedColumn] = useState([]);
  const groupes = useReduxSelector(({ commonData }) => commonData.groupes);
  const employeList = useReduxSelector(
    ({ commonData }) => commonData.employers
  );
  const isControlled = typeof isOpen === "boolean";
  const expanded = isControlled ? isOpen : internalExpanded;

  const collapseRef = useRef(null);
  const [isMounted, setIsMounted] = useState(expanded);

  useEffect(() => {
    if (!bulkMode) return;
    if (expanded) {
      setIsMounted(true);
      return;
    }
    const timer = setTimeout(() => setIsMounted(false), 300);
    return () => clearTimeout(timer);
  }, [bulkMode, expanded]);

  useEffect(() => {
    if (!bulkMode || !isControlled || !isOpen) return;

    function handleClickOutside(event) {
      if (
        collapseRef.current &&
        !collapseRef.current.contains(event.target) &&
        !event.target.closest("[data-import-data-button]")
      ) {
        onClose?.();
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [bulkMode, isControlled, isOpen, onClose]);

  useEffect(() => {
    setSelectedColumn(parentSelectedColumn);
  }, [parentSelectedColumn]);

  useEffect(() => {
    if (isControlled && isOpen) {
      setDataInjection(true);
      setColumnVisible(false);
    }
  }, [isControlled, isOpen]);

  const selectColumn = (column) => {
    if (selectedColumn.includes(column)) {
      setSelectedColumn((_selectedColumn) =>
        _selectedColumn.filter((clm) => clm !== column)
      );
    } else {
      setSelectedColumn((_selectedColumn) => [..._selectedColumn, column]);
    }
  };

  const showDataInject = () => {
    setInternalExpanded(true);
    setDataInjection(true);
    setColumnVisible(false);
  };

  const showColumnVisible = () => {
    setInternalExpanded(true);
    setColumnVisible(true);
    setDataInjection(false);
  };

  const closeSideCollapse = () => {
    if (isControlled) {
      onClose?.();
      return;
    }
    setInternalExpanded(false);
  };

  const cancelAndcloseSideCollapse = () => {
    setDataForChange((prevData) => ({
      ...prevData,
      ...tempDataForChange
    }));
    closeSideCollapse();
  };

  const applyInjection = () => {
    handleSaveData();
    setTimeout(() => closeSideCollapse(), 1000);
  };

  const applyColumnVisible = () => {
    const output = selectedColumn.sort((a, b) => {
      if (a.id < b.id) {
        return -1;
      }
      return 1;
    });
    setParentSelectedColumn(output);
    closeSideCollapse();
  };

  if (bulkMode && !isMounted) return null;

  return (
    <div
      ref={collapseRef}
      className={`${
        expanded
          ? "side-collapse side-collapse--expanded"
          : bulkMode
            ? "side-collapse arh-pointer-events-none"
            : "side-collapse"
      }${bulkMode ? " !arh-z-30" : ""}`}
    >
      {!hideCta && (
        <div className="side-collapse-cta">
          <div
            className={
              dataInjection ? "side-collapse-icon active" : "side-collapse-icon"
            }
            onClick={showDataInject}
          >
            <div className="position_relative">
              {SvgFunnelIcon()}
              <span
                className={
                  selectedItemNumber ? "badge--circle semibold" : "d-none"
                }
              >
                {selectedItemNumber}
              </span>
            </div>
          </div>
          <div
            className={
              columnVisible ? "side-collapse-icon active" : "side-collapse-icon"
            }
            onClick={showColumnVisible}
          >
            {SvgCheapListIcon()}
          </div>
        </div>
      )}
      <div className="arh-flex arh-h-full arh-w-full arh-flex-col arh-overflow-y-auto arh-px-14 arh-pb-8">
        {dataInjection && (
          <>
            <div className="arh-sticky arh-top-0 arh-z-10 arh-flex arh-items-center arh-justify-between arh-bg-white arh-py-10">
              <div className="arh-flex arh-items-center arh-gap-3 arh-leading-none">
                {bulkMode && (
                  <span className="arh-flex arh-items-center arh-justify-center"
                    style={{ width: 18, height: 18 }}
                  >
                    <SvgImportData color="#000000" />
                  </span>
                )}
                <h3 className="arh-m-0 arh-flex arh-items-center arh-text-left arh-font-poppins arh-text-lg arh-font-semibold arh-text-black">
                  {title}
                </h3>
              </div>
              <ButtonCloseModal
                onClick={closeSideCollapse}
                customClass="!arh-static"
              />
            </div>
            <div className="arh-mt-5 arh-flex arh-flex-col">
              <div className=" blackSvgColor">
                <label className="arh-font-poppins arh-text-xs arh-font-medium arh-text-black">
                  {t("Poste")}
                </label>
                <ListboxSimple
                  optionList={allPostes}
                  placeholder={t("Poste")}
                  name="poste"
                  optionTextAttribut="title"
                  setSelectedValue={(_post) =>
                    handleDataForChange(_post._id, "poste")
                  }
                  selectedValue={allPostes?.find(
                    (_post) => _post._id === dataForChange?.poste
                  )}
                  noRadio
                  showReset
                />
              </div>
              <div className=" position_relative  blackSvgColor mt-3">
                <label className="arh-font-poppins arh-text-xs arh-font-medium arh-text-black">
                  {t("Emplacement")}
                </label>
                <ListboxSimple
                  placeholder={t("Emplacement")}
                  name="emplacement"
                  optionList={emplacementList}
                  selectedValue={dataForChange?.emplacement || []}
                  setSelectedValue={(emplacement) => {
                    handleDataForChange(emplacement, "emplacement");
                  }}
                  withSearch
                  multiple
                  showReset
                />
              </div>
              <div className=" blackSvgColor mt-3">
                <label className="arh-font-poppins arh-text-xs arh-font-medium arh-text-black">
                  {t("Permission")}
                </label>
                <ListboxSimple
                  optionList={allPermissions}
                  placeholder={t("Permission")}
                  name="authorization"
                  optionTextAttribut="role"
                  setSelectedValue={(_role) =>
                    handleDataForChange(_role._id, "authorization")
                  }
                  selectedValue={allPermissions?.find(
                    (_role) => _role._id === dataForChange?.authorization
                  )}
                  noRadio
                  showReset
                />
              </div>
              <div className=" blackSvgColor mt-3">
                <label className="arh-font-poppins arh-text-xs arh-font-medium arh-text-black">
                  {t("Supérieur hiérarchique")}
                </label>
                <ListboxEmploye
                  optionList={employeList}
                  placeholder={t("Supérieur hiérarchique")}
                  name="valueHierarchicalSelected"
                  selectedValue={employeList?.find(
                    (_employee) =>
                      _employee.id === dataForChange.valueHierarchicalSelected
                  )}
                  setSelectedValue={(employee) =>
                    handleDataForChange(
                      employee.id,
                      "valueHierarchicalSelected"
                    )
                  }
                  withSearch
                  showReset
                  noRadio
                />
              </div>
              <div className=" blackSvgColor mt-3">
                <label className="arh-font-poppins arh-text-xs arh-font-medium arh-text-black">
                  {t("Genre légal")}
                </label>
                <ListboxSimple
                  optionList={translaGenre}
                  placeholder={t("Genre légal")}
                  name="legalGender"
                  setSelectedValue={(_gender) =>
                    handleDataForChange(_gender._id, "legalGender")
                  }
                  selectedValue={translaGenre?.find(
                    (_gender) => _gender._id === dataForChange?.legalGender
                  )}
                  noRadio
                  showReset
                  withTooltip
                />
              </div>

              <div className=" blackSvgColor mt-3">
                <label className="arh-font-poppins arh-text-xs arh-font-medium arh-text-black">
                  {t("Groupe")}
                </label>
                <ListboxGroupe
                  placeholder={t("Groupe")}
                  name="Groupes"
                  optionList={groupes || []}
                  selectedValue={dataForChange?.groupes || []}
                  setSelectedValue={(selectedGroup) => {
                    handleDataForChange(selectedGroup, "groupes");
                  }}
                  classLabel="arh-flex"
                  showReset
                />
              </div>

              <div>
                <BtnActions
                  title1={t("Annuler")}
                  events1={cancelAndcloseSideCollapse}
                  title2={t("Appliquer")}
                  events2={applyInjection}
                  colorTheme="green"
                  disabled={selectedItemNumber ? false : true}
                />
              </div>
            </div>
          </>
        )}

        {columnVisible && (
          <>
            <div className="arh-sticky arh-top-0 arh-z-10 arh-flex arh-items-center arh-justify-between arh-bg-white arh-py-10">
              <h3 className="arh-text-left arh-font-poppins arh-text-lg arh-font-semibold arh-text-black">
                {t("Colonnes visibles")}
              </h3>
              <ButtonCloseModal
                onClick={closeSideCollapse}
                customClass="!arh-static"
              />
            </div>
            <div className="arh-mt-4 arh-flex arh-flex-col arh-space-y-2">
              {TableImportList.map((column, index) => {
                return (
                  <CheckboxSimple
                    id={index}
                    key={column.id}
                    noRadio={false}
                    name={column.name}
                    checked={selectedColumn?.some(
                      (selected) => selected.name === column.name
                    )}
                    fontLabel="arh-text-[13px] arh-font-normal"
                    label={t(column.name)}
                    onClick={() => selectColumn(column)}
                  />
                );
              })}
            </div>
            <div className="arh-mt-auto">
              <BtnActions
                title1={t("Annuler")}
                events1={closeSideCollapse}
                title2={t("Appliquer")}
                events2={applyColumnVisible}
                colorTheme="green"
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default SideCollapse;
